export class ApaStylesDto {
    id : number ;
    style : string;
    constructor(id:number,style : string
    ){
    this.id = id ,
    this.style = style
    }
}